import apiClient from '@disco/api/server'
import type { NotesNotificationPreference } from '@disco/api/server'

import { api } from './index'

export const notificationPreferencesApi = api.injectEndpoints({
  endpoints: build => ({
    getNotesNotificationPreference: build.query<
      NotesNotificationPreference,
      void
    >({
      queryFn: async () => {
        try {
          return { data: await apiClient.getNotesNotificationPreference() }
        } catch (error) {
          return { error }
        }
      },
    }),
  }),
})

export const { useGetNotesNotificationPreferenceQuery } =
  notificationPreferencesApi
